module.exports = __webpack_public_path__ + "img/showStatus0.fa21ee30.png";